import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { T05SiteFooter } from '../../landing-templates/t05-launchdarkly/T05SiteFooter';
import { T05ArkoDropPanel, T05ArkoNavButton, T05ArkoProvider } from '../../landing-templates/t05-launchdarkly/T05ArkoWidget';
import { T05SiteNavBrand, useT05HomeLinkClick } from '../../landing-templates/t05-launchdarkly/T05SiteNavBrand';
import './t05-product.css';

export interface T05NavAnchor {
  href: string;
  label: string;
}

export interface T05ProductShellProps {
  children: React.ReactNode;
  productLabel: string;
  navAnchors?: T05NavAnchor[];
  onLoginClick?: () => void;
  onDemoClick?: () => void;
}

export const T05ProductShell: React.FC<T05ProductShellProps> = ({
  children,
  productLabel,
  navAnchors = [],
  onLoginClick,
  onDemoClick,
}) => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const onHomeClick = useT05HomeLinkClick(() => setMobileNavOpen(false));

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <T05ArkoProvider>
    <div className="landing-template-t05 t05-product-page" data-product-template="t05">
      <div className="t05-ambient" aria-hidden>
        <div className="t05-ambient__grid" />
        <div className="t05-ambient__orb t05-ambient__orb--hero" />
        <div className="t05-ambient__orb t05-ambient__orb--section" />
      </div>

      <div className="t05-shell">
        <div className="t05-nav-wrap">
          <nav className="t05-nav" aria-label="Produktnavigation">
            <T05SiteNavBrand productLabel={productLabel} />
            {navAnchors.length > 0 && (
              <div className="t05-nav__links">
                {navAnchors.map((a) => (
                  <a key={a.href} href={a.href}>
                    {a.label}
                  </a>
                ))}
              </div>
            )}
            <div className="t05-nav__actions">
              <T05ArkoNavButton />
              {onLoginClick && (
                <button type="button" className="t05-nav__ghost" onClick={onLoginClick}>
                  Login
                </button>
              )}
              {onDemoClick && (
                <button type="button" className="t05-btn t05-btn--primary t05-btn--sm" onClick={onDemoClick}>
                  Demo anfragen
                </button>
              )}
            </div>
            <button
              type="button"
              className="t05-nav__toggle"
              onClick={() => setMobileNavOpen((o) => !o)}
              aria-expanded={mobileNavOpen}
              aria-label={mobileNavOpen ? 'Menü schließen' : 'Menü öffnen'}
            >
              {mobileNavOpen ? <X size={18} /> : <Menu size={18} />}
            </button>
            <div className={`t05-nav__mobile-menu${mobileNavOpen ? ' t05-nav__mobile-menu--open' : ''}`}>
              <Link to="/" onClick={onHomeClick}>
                Startseite
              </Link>
              {navAnchors.map((a) => (
                <a key={a.href} href={a.href} onClick={() => setMobileNavOpen(false)}>
                  {a.label}
                </a>
              ))}
              <Link to="/recht" onClick={() => setMobileNavOpen(false)}>
                Rechtliches
              </Link>
              {onLoginClick && (
                <button type="button" onClick={() => { onLoginClick(); setMobileNavOpen(false); }}>
                  Login
                </button>
              )}
              {onDemoClick && (
                <button
                  type="button"
                  onClick={() => {
                    onDemoClick();
                    setMobileNavOpen(false);
                  }}
                >
                  Demo anfragen
                </button>
              )}
            </div>
          </nav>
          <T05ArkoDropPanel />
        </div>

        {children}

        <T05SiteFooter variant="product" />
      </div>
    </div>
    </T05ArkoProvider>
  );
};
